import { Box } from 'grommet'
import styled, { css } from 'styled-components'

export const Wrapper = styled(Box)`
  ${({ theme }) => css`
    margin-top: ${theme.newSpaces.xl5}px;

    h2 {
      text-transform: none;
    }

    p {
      white-space: pre-wrap;

      ${theme.below.laptop`
        white-space: normal;
      `}
    }

    &:not(:last-child) {
      margin-bottom: 0;
    }

    & > div > div {
      ${theme.above.laptopL`
        max-width: 1360px;

        & > div {
          max-width: 360px;
        }
      `}

      ${theme.below.laptopL`
        max-width: 998px;

        & > div {
          max-width: 310px;
        }
      `}

      ${theme.below.laptop`
        justify-content: space-between;
      `}

      ${theme.below.mobileXL`
        justify-content: flex-start;
        padding: 0;

        & > div {
          max-width: 294px;
        }

        a {
          ${theme.getTypography('mobile', 'body', 'body4')}
        }

        p {
          ${theme.getTypography('mobile', 'body', 'body4')}
        }
      `}
    }

    ${theme.below.laptop`
      padding: 0 ${theme.newSpaces.sm}px;
    `}

    ${theme.below.mobileXL`
      margin-top: ${theme.newSpaces.lg}px;
      padding: 0 ${theme.newSpaces.xl}px;
    `}
  `}
`
